var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFollowerVine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 569,
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#065e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#328e72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2048") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    display: "inline"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m11.58,48.89c3.68,-18.95 14.74,-37.37 28.42,-41.58c13.68,-4.21 38.95,-3.16 51.58,2.63c12.63,5.79 28.42,28.42 34.74,46.32c6.32,17.89 21.58,38.42 31.58,49.53c10,11.11 40.53,35.74 76.32,27.37c35.79,-8.37 49.47,-36.89 52.11,-54.74c2.63,-17.84 1.05,-50.58 -41.05,-63.21c-42.11,-12.63 -80.53,13.16 -92.11,23.74c-11.58,10.58 -39.47,39.95 -50.53,54.16c-11.05,14.21 -28.95,43.16 -34.21,63.68c-5.26,20.53 0.53,45.79 13.68,63.74c13.16,17.95 38.95,22.58 53.16,17.89c14.21,-4.68 40,-32.68 58.95,-43.16c18.95,-10.47 45.26,-18.47 67.37,-8.42c22.11,10.05 28.42,23.63 30,35.21c1.58,11.58 0.53,35.26 -9.47,45.79c-10,10.53 -38.42,21.58 -48.95,40c-10.53,18.42 -13.16,43.16 -11.58,59c1.58,15.84 4.74,31.53 21.58,41.53c16.84,10 31.58,10 43.68,17.42c12.11,7.42 20,23.11 22.63,33.16c2.63,10.05 2.63,40.47 0.53,50.53c-2.11,10.05 -5.26,29.95 -21.58,31.58c-16.32,1.63 -34.21,-12.68 -42.11,-16.84c-7.89,-4.16 -23.68,-17.42 -41.58,-3.68c-17.89,13.74 -12.11,35.74 -38.42,35.26c-26.32,-0.47 -39.47,-66.37 -71.05,-51.58c-31.58,14.79 -47.37,19.95 -72.63,-2.63c-25.26,-22.58 -17.89,-82.16 3.16,-100.58c21.05,-18.42 45.26,13.68 66.32,10.05c21.05,-3.63 31.05,-21.11 38.42,-35.26c7.37,-14.16 11.05,-49.53 -10,-65.26c-21.05,-15.74 -37.37,6.79 -73.68,-12.11c-36.32,-18.89 -36.84,-59.53 -40,-82.11c-3.16,-22.58 1.05,-148.47 4.74,-167.42z",
    fill: "#ff0000",
    fillOpacity: 0.01,
    id: "svg_5",
    stroke: "#f90000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFollowerVine1);
export default __webpack_public_path__ + "static/media/mobileFollowerVine1.6538778422b1b69fdc929325bc9b2247.svg";
export { ForwardRef as ReactComponent };